<ng-container *ngIf="!filterActive">{{text}}</ng-container>
<span *ngIf="filterActive" class="text-secondary">{{begin}}<span class="text-danger">{{filterHit}}</span>{{end}}</span>